/* tslint:disable */
/* eslint-disable */
export enum ParameterAttributes {
  None = 'None',
  In = 'In',
  Out = 'Out',
  Lcid = 'Lcid',
  Retval = 'Retval',
  Optional = 'Optional',
  HasDefault = 'HasDefault',
  HasFieldMarshal = 'HasFieldMarshal',
  Reserved3 = 'Reserved3',
  Reserved4 = 'Reserved4',
  ReservedMask = 'ReservedMask'
}
